import { Component, DestroyRef, inject, input, OnInit, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'quantity-control',
  templateUrl: './quantity-control.component.html',
  styleUrls: ['./quantity-control.component.scss'],
  imports: [ReactiveFormsModule]
})
export class QuantityControlComponent implements OnInit {

  qtyControl: UntypedFormControl;
  readonly initialValue = input<number>(1);
  readonly valueChanged = output<number>();

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
  }

  ngOnInit(): void {
    this.qtyControl = new UntypedFormControl(this.initialValue(), { updateOn: 'blur' });
    this.qtyControl.valueChanges
      .pipe( takeUntilDestroyed(this.destroyRef) )
      .subscribe(value => this.valueChanged.emit(value));
  }

  incrementQty() {
    let qty = this.getValue();
    this.setValue(++qty);
  }

  decrementQty() {
    let qty = this.getValue();
    if (qty <= 1) { return; }

    this.setValue(--qty);
  }

  setValue(value: number, emitEvent: boolean = true) {
    this.qtyControl.setValue(value, { emitEvent });
  }

  getValue() {
    return this.qtyControl.value;
  }
}
